module.exports = __webpack_public_path__ + "static/media/logoLux.911273e1.svg";